import { GridProps, SxProps, Theme } from '@mui/material';

export const gridItemLeftStyles: GridProps & { sx?: SxProps<Theme> } = {
  size: 1.5,
  sx: {
    display: 'flex',
    justifyContent: 'center',
  },
};

export const gridItemRightStyles: GridProps = { size: 10.5 };
